import React from 'react'

export const MagnifierIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 15.3492L11.6556 12.0048M13.4444 7.57147C13.4444 11.0079 10.6587 13.7937 7.22222 13.7937C3.78578 13.7937 1 11.0079 1 7.57147C1 4.13503 3.78578 1.34924 7.22222 1.34924C10.6587 1.34924 13.4444 4.13503 13.4444 7.57147Z"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
